const colors = {
  colors: {
    // layout
    primary: '#87CC2F',
    primaryDark: '#599e00',
    secondary: '#450d0d',
    accent: '#d93921',
    background: '#fcfff2',
    light: '#f7fafc',
    dark: '#592203',
    mutedBg: '#f1f1f1',
    // UI
    text: '#181818',
    textBody: '#585151',
    textMuted: '#9da2a0', // #8b8a90
    white: '#fff',
    black: '#26272a',
    transparent: 'transparent',
    gray: [
      null,
      '#f7fafc',
      '#edf2f7',
      '#e2e8f0',
      '#cbd5e0',
      '#a0aec0',
      '#718096',
      '#4a5568',
      '#2d3748',
      '#1a202c'
    ]
  }
}

export default colors
